import { render, staticRenderFns } from "./Subrubro.vue?vue&type=template&id=6f984d42&"
import script from "./Subrubro.vue?vue&type=script&lang=js&"
export * from "./Subrubro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports